import { Input } from 'reactstrap';
import { isNewEvidence } from '@utils/survey/evidence';
import { EvidenceFile, HandleNewEvidenceFn } from '@g17eco/types/file';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { isAddedToLibrary } from '@utils/files';

export const AddToLibraryCheckbox = (props: { file: EvidenceFile; handleAddToLibrary?: HandleNewEvidenceFn }) => {
  const { file, handleAddToLibrary } = props;

  const isExisting = !isNewEvidence(file);
  const isInLibrary = isExisting && isAddedToLibrary(file);

  // Don't render for new evidence without handler
  if (!isExisting && !handleAddToLibrary) {
    return null;
  }

  // Don't render for existing files that were never in library
  if (isExisting && !isInLibrary) {
    return null;
  }

  const isChecked = isExisting ? isInLibrary : (file.saveToLibrary ?? false);

  const tooltipText = isExisting && isInLibrary
    ? 'Document is now in Document Library. To remove, contact your administrator.'
    : undefined;

  return (
    <SimpleTooltip text={tooltipText}>
      <div className='d-flex gap-1 mt-2' data-testid='add-to-library-checkbox'>
        <Input
          type='checkbox'
          checked={isChecked}
          disabled={isExisting}
          onChange={() => {
            if (!isExisting && handleAddToLibrary) {
              handleAddToLibrary(file);
            }
          }}
        />
        <span>Also add to Document Library</span>
      </div>
    </SimpleTooltip>
  );
};
